import { defineComponent } from 'vue';

import KeywordHelper from './KeywordHelper.class';

export default defineComponent({
	setup: () => {
		const component = new KeywordHelper();

		return {
			helperContent: component.helperContent,
			KeywordHelperType: component.KeywordHelperType,
		};
	},
});
